import { DataBrokersNavigation } from './DataBrokersNavigation';

/**
 * Initializes the data brokers navigation functionality for each matching block on the page.
 */
document.querySelectorAll( '.b-data-brokers-navigation' ).forEach( ( block ) => {

	new DataBrokersNavigation( block );

} );
